(() => {
  'use strict';
  const root = document.body.dataset.root.replace(/\/?$/, '/');
  const currency = document.body.dataset.currency || 'AUD';
  const money = value => {
    const format=config.moneyFormat;
    const token=typeof format==='string' && format.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|apostrophe|space)_separator)?)\s*\}\}/);
    if(token && currency===(config.shopCurrency || currency)){
      const decimals=token[1].includes('no_decimals')?0:2;
      let amount=new Intl.NumberFormat('en-US',{minimumFractionDigits:decimals,maximumFractionDigits:decimals}).format(value/100);
      if(token[1].includes('comma_separator'))amount=amount.replace(/,/g,'~').replace(/\./g,',').replace(/~/g,'.');
      if(token[1].includes('apostrophe_separator'))amount=amount.replace(/,/g,"'");
      if(token[1].includes('space_separator'))amount=amount.replace(/,/g,' ');
      return format.replace(token[0],amount).replace(/<[^>]*>/g,'').replace(/&nbsp;/g,' ').replace(/&amp;/g,'&');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency}).formatToParts(value/100).map(part=>part.type==='currency' && part.value==='$' ? (currency==='AUD'?'A$':`${currency} `) : part.value).join('');
  };
  const config = JSON.parse(document.querySelector('[data-commerce-config]')?.textContent || '{}');
  const session = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key,value) { try { sessionStorage.setItem(key,value); } catch {} }
  };
  const recordedCode = session.get('welcome-code');
  let claimedCode = recordedCode === config.code ? recordedCode : '';
  let celebratedCode = session.get('celebrated-code') || '';
  const codeTitle = value => String(value || '').trim().toLowerCase();
  const lineSignature = item => JSON.stringify([Number(item.variant_id), item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))]);
  const readDiscounts = content => {
    try { return JSON.parse(content?.querySelector('[data-cart-discounts]')?.textContent || '[]'); } catch { return []; }
  };
  let activeRequest = false;
  let persistentError = '';
  let pendingFocus = null;
  async function api(path, data) {
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),15000);
    try {
      const response = await fetch(root + path, {signal:controller.signal,method:data ? 'POST':'GET', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, ...(data ? {body:JSON.stringify(data)}:{})});
      let result;
      try { result = await response.json(); } catch { throw new Error('We could not connect to your cart. Please refresh the page and try again.'); }
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
      return result;
    } catch(caught) {
      if(caught.name==='AbortError')throw new Error('The store took too long to respond. Check your bag before trying again.');
      throw caught;
    } finally {clearTimeout(timer);}
  }
  function error(message) {
    persistentError=message;
    const targets = document.querySelectorAll('[data-product-error], [data-cart-error]');
    targets.forEach(target => {target.textContent=message;target.hidden=!message;});
    if (message) window.HearthUI?.toast(message);
  }
  function savedCode() { return config.code && claimedCode === config.code ? config.code : ''; }
  // Offer prices are a storefront preview; actual bag totals always come from Shopify.
  function offerPrice(price, unlocked=Boolean(savedCode())) {
    const amount=Math.max(0,Number(config.welcomeAmount) || 1000);
    return Math.max(0,Number(price) - (unlocked ? amount : 0));
  }
  function updateCoupon(cart, discounts, celebrate=false) {
    const code = savedCode();
    const applications = discounts || readDiscounts(document.querySelector('[data-cart-content]'));
    const matches = applications.filter(application => application.type === 'discount_code' && codeTitle(application.title) === codeTitle(code));
    const saving = matches.reduce((total, application) => total + Math.max(0, Number(application.total_allocated_amount) || 0), 0);
    const applied = Boolean(code && saving > 0);
    document.querySelectorAll('[data-product-section]').forEach(section => {
      section.classList.toggle('code-saved', Boolean(code));
      section.classList.toggle('code-applied', Boolean(code));
      section.dataset.discountConfirmed=String(applied);
      const coupon=section.querySelector('[data-claim-code]');
      const heading=coupon?.querySelector('strong');
      const message = section.querySelector('[data-coupon-message]');
      const token = section.querySelector('.coupon-token');
      if (heading && code) heading.textContent=applied ? `🎉 Your ${money(config.welcomeAmount || 1000)} Is Applied` : `🎉 Your ${money(config.welcomeAmount || 1000)} Is Unlocked`;
      if (message && code) message.textContent=applied ? 'Prices below include your saving.' : `Prices below include ${code}. Applied to eligible orders at checkout.`;
      if (token && code) token.textContent=`${code} ✓`;
      if(coupon && code)coupon.setAttribute('aria-pressed','true');
    });
    if(code && celebrate && celebratedCode!==code){
      celebratedCode=code;session.set('celebrated-code',code);
      const anchor=document.querySelector('[data-claim-code]');if(anchor)window.HearthUI?.celebrate(anchor);
    }
    return applied;
  }
  const sectionRequest = {sections:['cart-panel'],sections_url:location.pathname};
  function parseSection(html) {
    if(!html)return null;
    const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-content]');
    if(!content)return null;
    return {content,discounts:readDiscounts(content)};
  }
  async function cartSection() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root + '?sections=cart-panel', {signal:controller.signal, credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Please open your bag to check the latest total.');
      let sections;
      try { sections = await response.json(); } catch { throw new Error('We could not load your cart. Please refresh the page and try again.'); }
      if (!sections['cart-panel']) throw new Error('Please open your bag to check the latest total.');
      const parsed=parseSection(sections['cart-panel']);
      if(!parsed)throw new Error('Please open your cart to check the latest total.');
      return parsed;
    } finally { clearTimeout(timer); }
  }
  async function applyCode(code = savedCode()) {
    if (!code) return api('cart.js');
    const [existing,{discounts}]=await Promise.all([api('cart.js'),cartSection()]);
    const previousCodes = Array.isArray(existing.discount_codes) ? existing.discount_codes.map(item => item.code).filter(Boolean) : [];
    discounts.filter(item => item.type === 'discount_code').forEach(item => previousCodes.push(item.title));
    const codes = [...new Map([...previousCodes, code].filter(Boolean).map(value => [codeTitle(value), value])).values()];
    return api('cart/update.js', {discount:codes.join(','),...sectionRequest});
  }
  async function syncOffers(code=savedCode()) {
    if(code)return applyCode(code);
    return api('cart.js');
  }
  function captureFocus() {
    const active = document.activeElement;
    const scope = active?.closest('[data-cart-content]');
    const line = active?.closest('[data-line-key]');
    const control = active?.matches('[data-bed-colour]') ? `[data-bed-colour="${active.dataset.bedColour}"]` : active?.matches('[data-remove-bed]') ? `[data-remove-bed="${active.dataset.removeBed}"]` : active?.matches('[data-quantity-delta]') ? `[data-quantity-delta="${active.dataset.quantityDelta}"]` :
      ['data-line-quantity','data-remove-line','data-upgrade-line','data-upgrade-variant','data-checkout'].find(name => active?.hasAttribute(name));
    return scope ? {scope, key:line?.dataset.lineKey, variant:line?.dataset.variantId, index:[...scope.querySelectorAll('[data-line-key]')].indexOf(line), control:control?.startsWith('[') ? control : control ? `[${control}]` : null} : null;
  }
  function restoreFocus(state) {
    if (!state?.scope?.isConnected) return;
    const lines = [...state.scope.querySelectorAll('[data-line-key]')];
    const line = lines.find(item => item.dataset.lineKey === state.key) || lines.find(item => item.dataset.variantId === state.variant) || lines[Math.min(Math.max(state.index, 0), lines.length - 1)];
    const target = (state.key ? line?.querySelector(state.control || 'a') : state.scope.querySelector(state.control || 'a')) || state.scope.querySelector('[data-checkout],a,button');
    target?.focus();
  }
  async function refreshCart(open=false, response=null) {
    const {content,discounts}=parseSection(response?.sections?.['cart-panel']) || await cartSection();
    let cart;
    try{cart=JSON.parse(content.querySelector('[data-cart-state]')?.textContent || 'null');}catch{}
    if(!cart || !Number.isFinite(cart.item_count))cart=await api('cart.js');
    document.querySelectorAll('[data-cart-content]').forEach(target => {
      const editing=[...target.querySelectorAll('[data-cart-edit]')].map(node=>node.open);
      target.innerHTML=content.innerHTML;
      target.querySelectorAll('[data-cart-edit]').forEach((node,index)=>node.open=Boolean(editing[index]));
    });
    document.querySelectorAll('[data-cart-count]').forEach(badge => {badge.textContent=cart.item_count;badge.hidden=cart.item_count===0;});
    document.querySelectorAll('[data-open-cart]').forEach(button => button.setAttribute('aria-label', `Shopping bag, ${cart.item_count} ${cart.item_count===1?'item':'items'}`));
    const count = document.querySelector('[data-cart-dialog-count]'); if(count) count.textContent=cart.item_count;
    updateCoupon(cart, discounts, true);
    renderBedControls();
    renderUpgrades();
    if (persistentError) error(persistentError);
    // Replaced forms must remain locked until the current transaction completes.
    if (activeRequest) lockControls();
    if (open) window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'));

    return cart;
  }
  const lockedControls = new Map();
  function lockControls() {
    document.querySelectorAll('[data-product-section] button,[data-product-section] input,[data-product-section] select,[data-cart-form] button,[data-cart-form] input,[data-cart-form] select,[data-cart-form] textarea,[data-closing-add]').forEach(control => {
      if (!lockedControls.has(control)) lockedControls.set(control, control.disabled);
      control.disabled = true;
    });
    document.querySelectorAll('[data-cart-content]').forEach(node => node.setAttribute('aria-busy','true'));
  }
  async function transaction(action) {
    if (activeRequest) { window.HearthUI?.toast('Your bag is still updating. Please wait a moment.'); return; }
    pendingFocus = captureFocus();
    const opener = document.activeElement;
    activeRequest = true; error(''); lockControls();
    document.querySelectorAll('[data-cart-loading]').forEach(node => node.hidden=false);
    try {
      await action(opener);
    } catch (caught) {
      error(caught.message || 'Your bag could not be updated. Please check its current contents.');
      try { await refreshCart(); } catch { error(`${caught.message} Open your bag again to confirm its current contents.`); }
    } finally {
      activeRequest = false;
      lockedControls.forEach((disabled,control) => {if(control.isConnected)control.disabled=disabled;});
      lockedControls.clear();
      document.querySelectorAll('[data-cart-content]').forEach(node => node.removeAttribute('aria-busy'));
      document.querySelectorAll('[data-cart-loading]').forEach(node => node.hidden=true);
      document.dispatchEvent(new Event('commerce-idle'));
      restoreFocus(pendingFocus); pendingFocus=null;
    }
  }
  function linePack(packs, line) {
    const name=Object.keys(packs).find(key=>Number(packs[key].id)===Number(line.product_id));
    const count={single:1,duo:2,trio:3}[name];
    const product=packs[name];
    const variant=product?.variants.find(item=>Number(item.id)===Number(line.variant_id));
    // The destination catalogue must use one colour option per bed slot.
    if(!count || !variant || variant.options.length!==count)return null;
    return {name,count,product,variant};
  }
  function bedChange(packs, line, action) {
    const current=linePack(packs,line);
    if(!current)throw new Error('This set cannot be changed here. Please open its product page or contact the store.');
    const options=[...current.variant.options];
    let destination=current.name;
    if(action.type==='remove'){
      if(!Number.isInteger(action.index) || action.index<0 || action.index>=options.length)throw new Error('Please choose the bed you want to remove.');
      options.splice(action.index,1);
      if(!options.length)return null;
      destination=options.length===1?'single':'duo';
    }else if(action.type==='colour'){
      if(!Number.isInteger(action.index) || action.index<0 || action.index>=options.length)throw new Error('Please choose the bed colour again.');
      options[action.index]=action.value;
    }else throw new Error('This set change is unavailable.');
    const product=packs[destination];
    const variant=product?.variants.find(item=>item.options.length===options.length && item.options.every((value,index)=>value===options[index]));
    if(!variant)throw new Error('That colour combination is not offered. Your current set has been kept.');
    if(!variant.available)throw new Error('That colour combination is sold out. Your current set has been kept.');
    return variant;
  }
  function renderBedControls() {
    const packs=config.packs || {};
    const hasBundles=Boolean(packs.duo || packs.trio);
    document.querySelectorAll('[data-cart-bed-options]').forEach(container=>{
      container.replaceChildren();
      const line=container.closest('[data-line-key]');
      if(!line)return;
      const quantity=Number(line.querySelector('[data-line-quantity]')?.value);
      const current=linePack(packs,{product_id:line.dataset.productId,variant_id:line.dataset.variantId});
      const editor=container.closest('[data-cart-edit]');
      if(editor)editor.hidden=!current || !hasBundles;
      if(!current || !hasBundles)return;
      if(quantity>1){const note=document.createElement('p');note.className='cart-bed-note';note.textContent=`Colours and bed changes apply to each of these ${quantity} identical sets.`;container.append(note);}
      current.variant.options.forEach((value,index)=>{
        const row=document.createElement('div');row.className='cart-bed-row';
        const label=document.createElement('label');label.append(`Bed ${index+1} Color`);
        const select=document.createElement('select');select.dataset.bedColour=String(index);
        [...new Set(current.product.variants.map(variant=>variant.options[index]))].forEach(colour=>{
          const tuple=[...current.variant.options];tuple[index]=colour;
          const candidate=current.product.variants.find(variant=>variant.options.every((part,i)=>part===tuple[i]));
          const option=new Option(`${colour}${candidate?.available?'':' — unavailable'}`,colour);option.selected=colour===value;option.disabled=!candidate?.available && colour!==value;select.add(option);
        });
        label.append(select);row.append(label);
        const remove=document.createElement('button');remove.type='button';remove.className='cart-bed-remove';remove.dataset.removeBed=String(index);remove.textContent='Remove bed';remove.setAttribute('aria-label',`Remove bed ${index+1}${quantity>1?' from each set':''}`);row.append(remove);container.append(row);
      });
    });
  }
  function renderUpgrades() {
    const packs=config.packs || {};
    const offered=new Set();
    document.querySelectorAll('[data-cart-upgrade]').forEach(container=>{
      container.replaceChildren();
      const scope=container.closest('[data-cart-content]');
      if(offered.has(scope))return;
      const line=container.closest('[data-line-key]');
      if(Number(line.querySelector('[data-line-quantity]')?.value)!==1)return;
      const from=Object.keys(packs).find(key=>packs[key].id===Number(line.dataset.productId));
      const to=from==='single'?'duo':from==='duo'?'trio':from==='trio'?'single':null;
      if(!to || !packs[to])return;
      const current=packs[from].variants.find(variant=>variant.id===Number(line.dataset.variantId));
      if(!current)return;
      const candidates=packs[to].variants.filter(variant=>variant.available && (from==='trio' || current.options.every((option,index)=>variant.options[index]===option)));
      if(!candidates.length)return;
      offered.add(scope);
      scope.querySelectorAll('[data-cart-extra]').forEach(node=>node.hidden=true);
      const label=document.createElement('label');label.textContent='Add one more bed';
      const select=document.createElement('select');select.dataset.upgradeVariant='';
      candidates.forEach(variant=>select.add(new Option(variant.options.at(-1),variant.id)));
      label.append(select);
      const button=document.createElement('button');button.type='button';button.className='upgrade-button';button.dataset.upgradeLine='';
            const update=()=>{const variant=candidates.find(item=>String(item.id)===select.value);button.textContent=`Add Another Bed (ONLY +${money(from==='trio'?variant.price:variant.price-current.price)})`;};
      select.addEventListener('change',update);update();container.append(label,button);
    });
  }
  async function replaceLine(original, variant) {
    const signature=lineSignature(original);
    if(variant && Number(variant.id)===Number(original.variant_id))return;
    if(!variant){
      try{await api('cart/change.js',{id:original.key,quantity:0});}
      catch(caught){const cart=await api('cart.js');if(cart.items.some(item=>lineSignature(item)===signature))throw caught;}
      return;
    }
    const marker=`${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let additionError;
    try{await api('cart/add.js',{items:[{id:variant.id,quantity:original.quantity,properties:{...original.properties,_bundle_change:marker}}]});}
    catch(caught){additionError=caught;}
    let cart=await api('cart.js');
    let oldLine=cart.items.find(item=>lineSignature(item)===signature);
    const added=cart.items.find(item=>item.properties?._bundle_change===marker);
    // A 422 or lost response can accompany a partial add. Never retry the add.
    if(!added || added.quantity!==original.quantity || additionError){
      if(oldLine && added)await api('cart/change.js',{id:added.key,quantity:0});
      throw new Error('The set change could not be completed. Please review your bag before trying again.');
    }
    if(!oldLine || oldLine.quantity!==original.quantity){
      if(oldLine)await api('cart/change.js',{id:added.key,quantity:0});
      throw new Error('Your bag changed while this set was updating. Please review its current contents.');
    }
    try{await api('cart/change.js',{id:oldLine.key,quantity:0});}
    catch(caught){
      // A failed response does not prove the write failed. Roll back only after
      // an authoritative read still shows the original set.
      cart=await api('cart.js');
      oldLine=cart.items.find(item=>lineSignature(item)===signature);
      const replacement=cart.items.find(item=>item.properties?._bundle_change===marker);
      if(oldLine){
        if(replacement)await api('cart/change.js',{id:replacement.key,quantity:0});
        throw new Error('The set change could not be completed. Your original set is still in your bag. Please check it before trying again.');
      }
      if(!replacement)throw caught;
    }
  }
  async function changeBed(line, action) {
    const cart=await api('cart.js');
    const original=cart.items.find(item=>item.key===line.dataset.lineKey);
    if(!original)throw new Error('Your bag has changed. Please review it before changing this bed.');
    const variant=bedChange(config.packs || {},original,action);
    await replaceLine(original,variant);
    await refreshCart(false);
  }
  async function upgradeLine(line) {
    const before=await api('cart.js');
    const original=before.items.find(item=>item.key===line.dataset.lineKey);
    const variantId=Number(line.querySelector('[data-upgrade-variant]')?.value);
    const packs=config.packs || {};
    const current=original && linePack(packs,original);
    const next=current?.name==='single'?packs.duo:current?.name==='duo'?packs.trio:current?.name==='trio'?packs.single:null;
    const chosen=next?.variants.find(variant=>variant.id===variantId && variant.available && (current.name==='trio' || current.variant.options.every((value,index)=>variant.options[index]===value)));
    if(!original || original.quantity!==1 || !chosen)throw new Error('Your bag has changed. Please review the available upgrade again.');
    if(current.name==='trio'){const response=await api('cart/add.js',{items:[{id:chosen.id,quantity:1}],...sectionRequest});await refreshCart(false,response);}
    else{await replaceLine(original,chosen);await refreshCart(false);}
  }

  async function claimCode() {
    if(!config.code)return;
    // Reward the click immediately, including with an empty bag or slow network.
    claimedCode=config.code;session.set('welcome-code',config.code);
    updateCoupon(null,[],true);
    document.dispatchEvent(new Event('welcome-offer-change'));
    const response=await syncOffers(config.code);
    return refreshCart(false,response);
  }
  function initialSelection(data, requestedPack, requestedVariant) {
    let pack=data[requestedPack] ? requestedPack : 'single';
    if(requestedVariant){
      const explicit=Object.keys(data).find(key=>data[key].variants.some(variant=>String(variant.id)===String(requestedVariant)));
      if(explicit)pack=explicit;
    }
    const variant=data[pack].variants.find(item=>String(item.id)===String(requestedVariant)) || data[pack].variants.find(item=>item.available) || data[pack].variants[0];
    return {pack,variant};
  }
  function optionsForPack(product, memory) {
    const prefix=product.variants.find(variant=>memory.every((value,index)=>index>=variant.options.length || variant.options[index]===value));
    return product.options.map((name,index)=>memory[index] ?? prefix?.options[index] ?? product.variants[0]?.options[index]);
  }
  function initialise(rootNode=document) {
    rootNode.querySelectorAll('[data-product-section]:not([data-commerce-ready])').forEach(section=>{
      section.dataset.commerceReady='true';
      const data=JSON.parse(section.querySelector('[data-product-data]')?.textContent || '{}');
      if(!data.single)return;
      const form=section.querySelector('.purchase-form');
      const initial=initialSelection(data,section.dataset.initialPack,section.dataset.initialVariant);
      let selectedPack=initial.pack;
      let selectedVariant=initial.variant;
      let gallerySelection='';
      if(!selectedVariant)return;
      let selectedOptions=[...selectedVariant.options];
      // Begin the Duo with Cocoa / Sand when the real catalogue offers it.
      if(!section.dataset.initialVariant && selectedPack==='duo'){
        const mixed=data.duo?.variants.find(variant=>variant.available && /^cocoa/i.test(variant.options[0]) && /^sand/i.test(variant.options[1]));
        if(mixed)selectedOptions=[...mixed.options];
      }
      const rememberedOptions=[...selectedOptions];
      form.querySelector('[data-variant-id]').disabled=false;
      const packRadio=section.querySelector(`[data-select-pack][value="${selectedPack}"]`);if(packRadio)packRadio.checked=true;
      const selects=section.querySelector('[data-variant-options]');
      const addButton=section.querySelector('[data-add-cart]');
      const closingButtons=[...document.querySelectorAll('[data-closing-add]')];
      closingButtons.forEach(button=>{button.hidden=false;button.onclick=()=>form.requestSubmit();});
      document.querySelectorAll('[data-closing-fallback]').forEach(link=>link.hidden=true);
      function renderOptions() {
        const product=data[selectedPack];
        selects.replaceChildren();
        product.options.forEach((name,index)=>{
          if(product.variants.length===1 && product.variants[0].title==='Default Title')return;
          const label=document.createElement('label');label.append(name.replace(/colour/gi,"Color"));
          const select=document.createElement('select');select.dataset.productOption=index;
          [...new Set(product.variants.map(variant=>variant.options[index]))].forEach(value=>{
            const option=new Option(value,value);option.selected=selectedOptions[index]===value;select.add(option);
          });
          if(![...select.options].some(option=>option.value===selectedOptions[index])){const unavailable=new Option(`${selectedOptions[index]} (unavailable)`,selectedOptions[index]);unavailable.selected=true;select.add(unavailable);}
          label.append(select);selects.append(label);
        });
      }
      function update() {
        const product=data[selectedPack];
        const options=[...selects.querySelectorAll('select')].map(select=>select.value);
        selectedVariant=product.variants.find(variant=>!options.length || variant.options.every((value,i)=>value===options[i]));
        selectedOptions=options.length ? options : (selectedVariant?.options || []);
        const completeCatalogue=!product.variant_count || product.variant_count<=product.variants.length;
        const available=Boolean(selectedVariant?.available && completeCatalogue);
        form.querySelector('[data-variant-id]').value=selectedVariant?.id || '';
        addButton.disabled=!available || activeRequest;
        addButton.textContent=!completeCatalogue ? 'Please contact us to choose this product' : selectedVariant ? (available?'Add to Cart':'Sold out'):'Combination unavailable';
        section.querySelector('[data-sticky-add]').disabled=!available || activeRequest;
        section.querySelector('[data-sticky-add]').textContent=addButton.textContent;
        const stock=section.querySelector('[data-stock-note]');
        const inventory=selectedVariant?.inventory;
        stock.textContent=available && inventory!==null && inventory>0
          ? (inventory<=Number(section.dataset.lowStock) ? `Almost gone · only ${inventory} left` : 'In stock · ready to ship')
          : '';
        document.querySelectorAll('[data-closing-stock]').forEach(note=>{note.textContent=stock.textContent;note.hidden=!stock.textContent;});
        closingButtons.forEach(button=>{button.disabled=!available || activeRequest;button.textContent=addButton.textContent;});
        Object.entries(data).forEach(([key,pack])=>{
          const variant=key===selectedPack ? selectedVariant : pack.variants.find(item=>item.available) || pack.variants[0];
          const price=section.querySelector(`[data-pack-price="${key}"]`);
          if(price)price.textContent=variant ? money(offerPrice(variant.price)) : 'Unavailable';
          const saving=section.querySelector(`[data-pack-saving="${key}"]`);
          if(saving && variant){
            const count={single:1,duo:2,trio:3}[key] || 1;
            const singlePrice=data.single.variants.find(item=>item.available)?.price || data.single.price;
            const compare=Number(variant.compare_at_price) || (section.dataset.bundleFamily==='true' ? singlePrice*count : 0);
            const total=offerPrice(variant.price);
            saving.textContent=count>1 && compare>total ? `Save ${Math.round((compare-total)/compare*100)}%` : section.dataset.bundleFamily==='true' ? `${count} ${count===1?'Bed':'Beds'}` : '';
          }
        });
        section.querySelector('[data-sticky-price]').textContent=selectedVariant ? money(offerPrice(selectedVariant.price)):'';
        const colourIndex=product.options.findIndex(name=>/colo[u]?r/i.test(name));
        const colour=options[colourIndex>=0?colourIndex:0];
        const mediaSelection=JSON.stringify([selectedVariant?.id,colour]);
        if(mediaSelection!==gallerySelection){if(gallerySelection)section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('show-variant',{detail:{colour,mediaId:selectedVariant?.media_id}}));gallerySelection=mediaSelection;}
        if(selectedVariant && (location.pathname===product.url || location.pathname===root+product.url.replace(/^\//,''))) {
          const url=new URL(location.href);url.searchParams.set('variant',selectedVariant.id);history.replaceState(null,'',url);
        }
      }
      section.addEventListener('change',event=>{
        if(event.target.matches('[data-select-pack]')){
          selectedOptions.forEach((value,index)=>rememberedOptions[index]=value);
          selectedPack=event.target.value;
          const next=data[selectedPack];
          selectedOptions=optionsForPack(next,rememberedOptions);
          renderOptions();update();
        } else if(event.target.matches('[data-product-option]')){update();selectedOptions.forEach((value,index)=>rememberedOptions[index]=value);}
      });
      form.addEventListener('submit',event=>{
        event.preventDefault();
        if(!selectedVariant?.available || addButton.disabled)return;
        window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'));
        transaction(async()=>{
          const response=await api('cart/add.js',{items:[{id:selectedVariant.id,quantity:1}],...sectionRequest});
          await refreshCart(false,response);
        });
      });
      section.querySelector('[data-sticky-add]')?.addEventListener('click',()=>form.requestSubmit());
      const sticky=section.querySelector('[data-sticky-purchase]');
      const mobilePurchase=window.matchMedia("(max-width:767px)");
      let primaryVisible=true,primaryBelow=true,closingVisible=false;
      const syncSticky=()=>{sticky.hidden=primaryVisible || (!mobilePurchase.matches && primaryBelow) || closingVisible;};
      mobilePurchase.addEventListener("change",syncSticky);
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===addButton){primaryVisible=mobilePurchase.matches ? entry.intersectionRatio>=1 : entry.isIntersecting;primaryBelow=entry.boundingClientRect.top>0;}else closingVisible=entry.isIntersecting;});syncSticky();},{threshold:[0,1]});
      observer.observe(addButton);const closing=document.querySelector('.closing-offer .button');if(closing)observer.observe(closing);
      section.querySelector('[data-claim-code]')?.addEventListener('click',()=>transaction(claimCode));
      document.addEventListener('commerce-idle',update);
      document.addEventListener('welcome-offer-change',update);
      renderOptions();update();updateCoupon();
    });
  }
  document.addEventListener('click',event=>{
    const extra=event.target.closest('[data-add-upsell]');
    if(extra){transaction(async()=>{const response=await api('cart/add.js',{items:[{id:Number(extra.dataset.addUpsell),quantity:1}],...sectionRequest});await refreshCart(false,response);});return;}
    const removedBed=event.target.closest('[data-remove-bed]');
    if(removedBed){event.preventDefault();transaction(()=>changeBed(removedBed.closest('[data-line-key]'),{type:'remove',index:Number(removedBed.dataset.removeBed)}));return;}
    const upgrade=event.target.closest('[data-upgrade-line]');
    if(upgrade){transaction(()=>upgradeLine(upgrade.closest('[data-line-key]')));return;}
    const opener=event.target.closest('[data-open-cart]');
    if(opener){event.preventDefault();window.HearthUI.showDialog(document.querySelector('[data-cart-dialog]'),opener);transaction(()=>refreshCart(false));return;}
    const delta=event.target.closest('[data-quantity-delta]');
    const removal=event.target.closest('[data-remove-line]');
    if(delta || removal){
      event.preventDefault();
      const line=(delta || removal).closest('[data-line-key]');
      const input=line.querySelector('[data-line-quantity]');
      const quantity=removal?0:Math.max(0,Number(input.value)+Number(delta.dataset.quantityDelta));
      transaction(async()=>{const response=await api('cart/change.js',{id:line.dataset.lineKey,quantity,...sectionRequest});await refreshCart(false,response);});
    }
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-bed-colour]')){transaction(()=>changeBed(event.target.closest('[data-line-key]'),{type:'colour',index:Number(event.target.dataset.bedColour),value:event.target.value}));return;}
    if(event.target.matches('[data-line-quantity]'))transaction(async()=>{
      const response=await api('cart/change.js',{id:event.target.dataset.key,quantity:Math.max(0,Math.floor(Number(event.target.value)||0)),...sectionRequest});await refreshCart(false,response);
    });
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-cart-form]');
    if(!form)return;
    event.preventDefault();
    if(activeRequest)return;
    // Native checkout uses the current server cart without a redundant update request.
    const checkoutForm=document.createElement('form');checkoutForm.method='post';checkoutForm.action=root+'cart';checkoutForm.hidden=true;
    const checkout=document.createElement('input');checkout.type='hidden';checkout.name='checkout';checkout.value='Checkout';checkoutForm.append(checkout);document.body.append(checkoutForm);
    HTMLFormElement.prototype.submit.call(checkoutForm);
  });
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  initialise();
  renderBedControls();
  renderUpgrades();
})();
